import { render, staticRenderFns } from "./testing.vue?vue&type=template&id=5b2423e4&scoped=true&"
import script from "./testing.vue?vue&type=script&lang=js&"
export * from "./testing.vue?vue&type=script&lang=js&"
import style0 from "./testing.vue?vue&type=style&index=0&id=5b2423e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2423e4",
  null
  
)

export default component.exports